import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();
const load = () => api.get("/branding").then((r) => { cache = r.data; listeners.forEach((l) => l(cache)); return cache; });

export const refreshBranding = (data) => {
  if (data) { cache = data; listeners.forEach((l) => l(cache)); return Promise.resolve(data); }
  return load();
};

export const logoUrl = (b, kind) => (b?.logos?.[kind] ? `${process.env.REACT_APP_BACKEND_URL}/api/branding/logo/${kind}?v=${b.logos[kind]}${b.tenant_id ? `&tn=${b.tenant_id}` : ""}` : null);

export const loadTenantBranding = (slug) => api.get("/branding", { params: { tenant: slug } }).then((r) => refreshBranding(r.data));

export const useBranding = () => {
  const [b, setB] = useState(cache);
  useEffect(() => {
    listeners.add(setB);
    if (!cache) load().catch(() => {});
    return () => listeners.delete(setB);
  }, []);
  return b || { _fallback: true, app_name: "Nouvelle CRM", color: "#2563eb", logos: {}, welcome_title: "", welcome_text: "" };
};

export const BrandLogos = ({ b, size = "h-9", fallback = true, dark = false, narrow = false }) => {
  const logos = ["manager", "company"].map((k) => logoUrl(b, k)).filter(Boolean);
  if (!logos.length && fallback) {
    return <img src="/nouvelle-crm-logo.png" alt="Nouvelle CRM" data-testid="brand-logo-default" className={`${size} w-auto shrink-0 object-contain ${dark ? "rounded bg-white/95 p-1" : ""}`} />;
  }
  return (
    <div className={`flex shrink-0 items-center ${narrow ? "gap-1.5" : "gap-3"}`}>
      {logos.map((src, i) => (
        <img key={src} src={src} alt={i ? "Logo azienda" : "Logo gestore"} data-testid={`brand-logo-${i}`}
          className={`${size} w-auto ${narrow ? "max-w-[56px]" : "max-w-[140px]"} object-contain ${dark ? "rounded bg-white/95 p-1" : ""}`} />
      ))}
    </div>
  );
};
